var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4988 5.5C15.4988 7.48663 13.9475 9 12.152 9C10.3565 9 8.80518 7.48663 8.80518 5.5C8.80518 3.51337 10.3565 2 12.152 2C13.9475 2 15.4988 3.51337 15.4988 5.5ZM17.4988 5.5C17.4988 8.53757 15.1049 11 12.152 11C9.19902 11 6.80518 8.53757 6.80518 5.5C6.80518 2.46243 9.19902 0 12.152 0C15.1049 0 17.4988 2.46243 17.4988 5.5ZM21.2921 21C19.3725 17.6527 15.9461 15.4766 12.1517 15.4766C8.35733 15.4766 4.93091 17.6527 3.01131 21H21.2921ZM22.2055 23H22.3594H24.3034C22.6612 17.4766 17.8416 13.4766 12.1517 13.4766C6.46182 13.4766 1.64223 17.4766 0 23H1.94434H2.09788H22.2055Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRed);
export default __webpack_public_path__ + "static/media/userRed.84f66b955a9d844cbb7e79b8dd60d27c.svg";
export { ForwardRef as ReactComponent };